import { NgModule } from "@angular/core";
import { RecruitmentApi } from "./recruitment-api";
import { RecruitmentAuth } from "./recruitment-auth";
import { RecruitmentResponses } from "./recruitment-responses";
import { AuthApi } from "./services/auth.api";

@NgModule({
    declarations: [],
    imports: [],
    providers: [
        RecruitmentApi,
        RecruitmentAuth,
        RecruitmentResponses,
        AuthApi
    ]
})
export class RecruitmentApiModule {
}


// WEBPACK FOOTER //
// ./src/shared/recruitment/recruitment-api.module.ts